module.exports = __webpack_public_path__ + "static/img/sjOne.26b7e22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjOne.jpg
// module id = 2tNv
// module chunks = 1